import { useRef, type UIEvent } from 'react';

export function useLinkedPreview() {
  const previewRef = useRef<HTMLDivElement>(null);
  function onFormScroll(event: UIEvent<HTMLElement>) {
    const form = event.currentTarget;
    const preview = previewRef.current;
    if (!preview) return;
    const formMax = form.scrollHeight - form.clientHeight;
    const previewMax = preview.scrollHeight - preview.clientHeight;
    if (formMax <= 0 || previewMax <= 0) return;
    preview.scrollTop = (form.scrollTop / formMax) * previewMax;
  }
  return { previewRef, onFormScroll };
}
